// 앰버서더 성과표의 period 라벨 — 서버는 daily "2026-08-03", monthly "2026-08" 로 준다 (api/ambassadorApi.ts).
// 모바일 표 폭을 아끼려고 일별은 연도를 떼고 "8.3 월" 로 줄이고, 연도는 월 구분선이 대신 보여준다.

const WEEKDAY_LABELS = ["일", "월", "화", "수", "목", "금", "토"];

const DAY_PERIOD_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;
const MONTH_PERIOD_REGEX = /^(\d{4})-(\d{2})/;

// "2026-08" / "2026-08-03" → "2026년 8월". 월 구분선과 월별 탭의 행 제목에 쓴다.
export function formatMonthLabel(period: string): string {
  const match = MONTH_PERIOD_REGEX.exec(period);
  if (!match) return period;
  return `${match[1]}년 ${Number(match[2])}월`;
}

// 월이 바뀌는 지점을 찾기 위한 그룹 키 — "2026-08-03" → "2026-08"
export function monthKey(period: string): string {
  return period.slice(0, 7);
}

// "2026-08-03" → { day: "8.3", weekday: "월" }. 형식이 다르면 원문을 그대로 두고 요일은 비운다.
export function formatDayLabel(period: string): {
  day: string;
  weekday: string;
} {
  const match = DAY_PERIOD_REGEX.exec(period);
  if (!match) return { day: period, weekday: "" };
  const [, year, month, day] = match;
  // 로컬 시간으로 만들어야 한다 — new Date("2026-08-03") 은 UTC 로 해석돼 KST 에서 하루 밀린다.
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return {
    day: `${Number(month)}.${Number(day)}`,
    weekday: WEEKDAY_LABELS[date.getDay()] ?? "",
  };
}
